module.exports = __webpack_public_path__ + "img/1122141708.3af55233.png";